// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_landing_landing_module_ts":"51a410db212bffb9","src_app_components_modulos_modulos_module_ts":"45af9580c2558af2","src_app_components_notfound_notfound_module_ts":"0cc6557fb5b797da"}[chunkId] + ".js";
};